import { PREMIUM_FEATURES, PREMIUM_SLIDES } from "constants/premium"
import { PremiumFeatureConfig, PremiumFeatureKey, PremiumSlide } from "types/premium.types"

export function getActivePremiumFeatures(): Partial<Record<PremiumFeatureKey, PremiumFeatureConfig>> {
  const entries = Object.entries(PREMIUM_FEATURES).filter(function ([_, config]) {
    return !config.hasOwnProperty("active") || config.active === true
  })
  return Object.fromEntries(entries) as Partial<Record<PremiumFeatureKey, PremiumFeatureConfig>>
}

export function getPremiumSlidesForActiveFeatures(): PremiumSlide[] {
  return PREMIUM_SLIDES.filter(function (slide) {
    if (slide.key === "main") {
      return true
    }

    const config = PREMIUM_FEATURES[slide.key as PremiumFeatureKey]
    return config && config.active !== false
  })
}
